export const getPropertyOwnerSchedulingPreferencesPayload = (preferences) => {
  const payloadEntries = [
    ['all_showings', preferences.selfSchedule],
    ['availability_buffer', preferences.availabilityBuffer],
    ['cluster_tours', preferences.clusterTours],
    ['hide_scheduling', preferences.hideScheduling],
    ['in_person_tours', preferences.inPerson],
    ['live_video_tour_type', preferences.liveVideo],
    ['number_of_scheduling_days', preferences.numberOfSchedulingDays],
    ['post_appointment_buffer', preferences.postAppointmentBuffer],
    ['pre_appointment_buffer', preferences.preAppointmentBuffer],
    ['self_guided_tours_block', preferences.selfGuidedToursBlock],
    ['self_guided_tours_enabled', preferences.selfGuidedToursEnabled],
    ['tour_duration', preferences.tourDuration],
    ['virtual_tour_links', preferences.virtualTourLinks],
    ['virtual_tour_links_mapping', preferences.virtualTourLinksMapping],
  ].filter(([_, value]) => value !== undefined);

  return Object.fromEntries(payloadEntries);
};
